import React, { Component } from "react";
import SubmitFeed from "./Elements/SubmitFeed";
import InputField from "./Elements/InputField";

class BlueskyFeed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hashtag: "",
      handle: "",
      error: false,
      handleError: false,
      loading: false,
      errorMsg: "This field is required"
    }
  }

  onTextChange = (e) => this.setState({ [e.target.name]: e.target.value, error: false, handleError: false });

  onSubmit = () => {
    const { updateStep, selectedFilterId } = this.props;
    const { hashtag, handle } = this.state;
    if (selectedFilterId == 1 && handle.trim().length == 0) {
      this.setState({ handleError: true });
    } else if (selectedFilterId == 2 && hashtag.trim().length == 0) {
      this.setState({ error: true, errorMsg: "This field is required" });
    } else {

      var obj = {
        networkId: 31,
        moderation: 0,
        connetedAccount: 0,
        feedType: selectedFilterId,
        filter: selectedFilterId,
        accountId: 0,
        hashtagCaption: 0,
        hashtagIGTV: 0,
        onlyReels: 0,
        productId: 4,
      }

      if (selectedFilterId == 1) {
        obj['feedText'] = handle.split('@').join('');
      } else if (selectedFilterId == 2) {
        obj['feedText'] = hashtag;
      }

      this.setState({ error: false, handleError: false, loading: true });

      updateStep(2, obj, () => this.setState({ loading: false }));
    }
  }

  render() {
    const { hashtag, handle, error, handleError, loading, errorMsg } = this.state;
    const { selectedFilterId } = this.props;

    return (
      <div className="ob-feed-form-wrapper w-100">
        {selectedFilterId == 2 ? <div className="selectSource-right mb-3">
          <div className="position-relative d-flex custom-input">
            <span className="hastag d-flex align-items-center">
              <i className={`fas fa-hashtag`}></i>
            </span>
            <InputField name={"hashtag"} placeholder="Enter hashtag here.." className="form-control p-3" value={hashtag} onChangeHandler={(e) => this.onTextChange(e)} />
          </div>
          {error && <span id="feedsslackkeyworderror" className="errorMessage required text-start">{errorMsg}</span>}
        </div> :
          <div className="selectSource-right mb-3">
            <div className="position-relative d-flex custom-input">
              <span className="hastag d-flex align-items-center">
                <i className={`fas fa-at`}></i>
              </span>
              <InputField name={"handle"} placeholder="Enter handle here.." className="form-control p-3" value={handle} onChangeHandler={(e) => this.onTextChange(e)} />
            </div>
            {handleError && <span id="feedsslackkeyworderror" className="errorMessage required text-start">This field is required</span>}
          </div>}
        <div className="click-next d-flex align-items-center py-3 px-4 rounded justify-content-between">
          <SubmitFeed loading={loading} onSubmit={this.onSubmit} onBack={this.props.backAction} disabled={selectedFilterId == 2 ? !hashtag.trim() : !handle.trim()} />
        </div>
      </div>
    )
  }
}

export default BlueskyFeed